







































































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import { Order } from "../models/Order";
import { OrderTable } from "../forms/OrderTableForm";
export default Vue.extend({
  mixins: [dialog, permission],
  data() {
    const realDuplicateOrders: OrderTable = {};
    const unrealDuplicateOrders: OrderTable = {};
    const realSearch = "";
    const unrealSearch = "";
    const isLoading = false;
    return {
      realDuplicateOrders,
      unrealDuplicateOrders,
      realSearch,
      unrealSearch,
      isLoading
    };
  },
  computed: {
    hasDuplicateDeletePermission() {
      return (this as any).hasPermission(PermissionName.DUPLICATE_DELETE);
    },
    hasDuplicateMarkPermission() {
      return (this as any).hasPermission(PermissionName.DUPLICATE_MARK);
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.getDuplicateOrders()]);
    this.isLoading = false;
  },
  methods: {
    async getDuplicateOrders() {
      try {
        const {
          data: orders
        } = await (this as any).$dep.orderUseCase.getDuplicateOrders();
        this.realDuplicateOrders = (this as any).$dep.orderUseCase.presenterDataTable(
          orders.realDuplicateOrders
        );

        this.unrealDuplicateOrders = (this as any).$dep.orderUseCase.presenterDataTable(
          orders.unrealDuplicateOrders
        );
      } catch (error) {
        console.log(error);
      }
    },
    async dialogDeleteOrders() {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบ Duplicate Orders",
        `คุณต้องการที่จะลบ Duplicate Orders ใช่ไหม?`
      );
      if (isComfirmed) {
        this.deleteOrders();
      }
    },

    async dialogMarkOrders() {
      const isComfirmed = await (this as any).alertConfirm(
        "Mark Duplicate Orders",
        `คุณต้องการที่จะ Mark Duplicate Orders ใช่ไหม?`
      );
      if (isComfirmed) {
        this.markOrders();
      }
    },

    async markOrders() {
      try {
        this.isLoading = true;
        await (this as any).$dep.orderUseCase.markDuplicateOrders(
          this.realDuplicateOrders
        );
        this.isLoading = false;
        (this as any).alertSuccess("Success", "Mark Duplicate Orders สำเร็จ");
        this.getDuplicateOrders();
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถ Mark Duplicate Orders ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    },

    async deleteOrders() {
      try {
        this.isLoading = true;
        await (this as any).$dep.orderUseCase.deleteRealDuplicateOrders();
        this.isLoading = false;
        (this as any).alertSuccess("Success", "ลบ Duplicate Orders สำเร็จ");
        this.getDuplicateOrders();
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError(
                "Error",
                "ไม่สามารถลบ Duplicate Orders ได้"
              )
            : (this as any).alertError("Error", error);
        }
      }
    }
  }
});
